import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Menu: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Hamburger menu">
      <path
        id="Vector"
        d="M3 17.0002H21M3 12.0002H21M3 7.00024H21"
        stroke="currentColor"
        strokeWidth="currentStrokeWidth"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default Menu;
